<template>
    <div class="plugin-features-container">
      <div class="feature-item" v-for="(feature, index) in features" :key="index">
        <img :src="feature.icon" alt="Feature Icon" class="feature-icon">
        <h3 class="feature-title">{{ feature.title }}</h3>
        <p class="feature-description">{{ feature.description }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        features: [
          {
            icon: require('@/assets/images/services/secondThree1.png'), 
            title: 'Recommend contextual research',
            description: 'Using intelligent matching algorithms, the plug-in recommends highly relevant research articles tailored to each reader’s field of interest which is offering content that aligns with their reading behavior, discipline, and topical focus.'
          },
          {
            icon: require('@/assets/images/services/secondThree2.png'), 
            title: 'Keep scholars informed',
            description: 'By surfacing the most recent and relevant developments in a given field, Contrimetric keeps scholars continuously informed and connected with the evolving research.'
          },
          {
            icon: require('@/assets/images/services/secondThree3.png'), 
            title: 'Designed for ease & access',
            description: 'Free to use and simple to integrate, the plug-in fits seamlessly into websites, digital libraries, repositories and journal platforms to deliver real value with zero friction.'
          }
        ]
      };
    }
  };
  </script>
  
  <style scoped lang="scss">
 
  .plugin-features-container {
   max-width: 1200px;
   margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .feature-item {
    width: 31%;
    min-width: 250px;
    background-color: #f9f9f9;
    border: 1px solid #eaeaea;
    border-radius: 15px;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    h3 p{
        width: 90%;
    }
  }
  
  .feature-item:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    transform: translateY(-3px);
  }
  
  .feature-icon {
    width: 100%;
    background-size: cover;
    margin-bottom: 10px;
  }

  .feature-description, .feature-title{
    text-align: left;
    padding: 0 14px;
    line-height: 30px;
    hyphens: auto;
    overflow-wrap: break-word;
  }
  
  .feature-title {
    font-size: 16px;
    color: #333;
    margin-bottom: 5px;

  }
  
  .feature-description {
    font-size: 14px;
    color: #666;
    line-height: 24px;
    padding-bottom: 10px;
  }
  </style>